const React = require("react");
const T = React.PropTypes;

require("./ProgressBar.less");

/*
 * Not currently used
 */
const ProgressBar = React.createClass({
    propTypes: {
        CompletedCount: T.number.isRequired,
        TotalCount: T.number.isRequired
    },
    render() {
        const completionPct = (this.props.CompletedCount / this.props.TotalCount) * 100;
                
        return (<div className="cs-ProgressBar">
                <div className="cs-ProgressBar__box">
                    <div className="cs-ProgressBar__box--bar" style={{ width: completionPct + "%" }}></div>
                </div>
                <p className="cs-ProgressBar--print">Progress: {completionPct}% complete</p>
            </div>);
    }
});

module.exports = ProgressBar;


// WEBPACK FOOTER //
// ./src/components/ProgressBar/ProgressBar.jsx